//api 权限角色 接口处理
import request from "@/utils/request.js";
export default {
    //角色列表
    getRoleList(param) {
        return request.post("/merchant/Authority.role/roleList", param, false, true);
    },
    //角色更新
    roleUpdate(param) {
        return request.post("merchant/Authority.role/roleNameUpdate ", param, false, true);
    },
    //角色权限更新
    roleAuthorityUpdate(param) {
        return request.post("merchant/Authority.role/roleAuthorityUpdate", param, false, true);
    },
    //角色删除
    roleDel(param) {
        return request.post("merchant/Authority.role/roleDel", param, false, true);
    },
    //角色回显
    roleInfo(param) {
        return request.post("merchant/Authority.role/roleInfo", param, false, true);
    },

    //部门列表
    getDepartmentList(param) {
        return request.post("merchant/Authority.department/indexList", param, false, true);
    },
    //部门更新
    getDepartmentUpdate(param) {
        return request.post("merchant/Authority.department/dataUpdate", param, false, true);
    },
    //部门删除
    getDepartmentDel(param) {
        return request.post("merchant/Authority.department/dataDel", param, false, true);
    },
    //员工删除
    accountDel(param) {
        return request.post("merchant/Authority.account/accountDel", param, false, true);
    },
    //员工详情
    accountInfo(param) {
        return request.post("merchant/Authority.account/accountInfo", param, false, true);
    },
    //员工列表
    accountList(param) {
        return request.post("merchant/Authority.account/accountList", param, false, true);
    },
    //员工更新
    accountUpdate(param) {
        return request.post("merchant/Authority.account/accountUpdate", param, false, true);
    },
}